module.exports = __webpack_public_path__ + "media/images/emblems/Grenchen-blason-f56d88a49056021d641379d389e900d2.png";